<template>
  <div v-if="activitiesFiltered.length">
    <div
      class="caption d-flex grey--text text--darken-1 pb-"
      style="position: relative;"
    >
      <div class="d-flex align-center" style="margin-bottom: 1px;">
        <div style="width: 90px" v-if="!hideText">{{ title }}:</div>
        <div
          class="px-1"
          :style="{
            marginLeft: '1px',
            fontSize: '9px',
            borderRadius: '2px',
            fontWeight: 'bold',
            background: item.color,
            color: item.identifier === 'VX' ? 'black' : 'white'
          }"
          v-for="(item, $i) in activitiesFiltered"
          :key="$i"
        >
          {{
            item.identifier === 'VX'
              ? parseVx(type === 'after' ? item.placeEnd : item.placeStart)
              : item.identifier
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import orderby from 'lodash.orderby'
export default {
  name: 'ActivtyRow',

  props: {
    activities: {
      type: Array
    },
    type: String,
    hideText: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    activitiesFiltered() {
      return orderby(
        this.type === 'before'
          ? this.activities.filter(x => [0].includes(x.position))
          : this.activities.filter(x => [null, 1].includes(x.position)),
        [x => x.identifier === 'VX'],
        ['desc']
      )
    },

    title() {
      return this.type === 'after' ? 'Efter ankomst' : 'Innan avgång'
    }
  },

  methods: {
    parseVx(vx) {
      if (vx.includes('_')) {
        return vx.split('_')[1]
      }
      return vx
    }
  }
}
</script>
